import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseListComponent } from 'src/app/base/components/base-list.component';
import { ProcessoCadastro, ProcessoPermission } from '../../../models/processo-cadastro.model';
import { ProcessoCadastroService } from '../../../services/processo-cadastro.service';

@Component({
  selector: 'app-processo-list',
  templateUrl: './processo-list.component.html',
  styleUrls: ['./processo-list.component.scss']
})
export class ProcessoListComponent extends BaseListComponent<ProcessoCadastro> implements OnInit {

  list: ProcessoCadastro[];
  permission: ProcessoPermission;

  constructor(
    public activatedRoute: ActivatedRoute,
    public processoCadastroService: ProcessoCadastroService,
  ) {
    super();
  }

  ngOnInit() {
    this.search();
  }

  search(filterSave = false) {
    this.loading();
    this.addSub(
      this.processoCadastroService.findAll().subscribe({
        next: (res) => {
          this.permission = res['permission'];
          this.list = res['process_list'];
          this.loaded();
        },
        error: (erro) => {
          this.msgError(erro?.message);
          this.loaded();
        },
      })
    );
  }
}
